import React, { PureComponent } from 'react';
import { LeftPage, LeftTopBox, LeftBottomBox } from './style';
import { ModuleTitle } from '../../style/globalStyledSet';
import { BorderBox12, BorderBox13 } from '@jiaminghi/data-view-react';
import TrafficSituation from './charts/TrafficSituation';
import UserSituation from './charts/UserSituation';
import { connect } from 'dva';
import { getLeftPageData } from '../../services/index';

import { formatTime } from '../../utils';
class index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      detailsList: '',
      num1:  455000,
      num2:  141000,
      num3:  147000,
      num4:  3.09,
      num5:  900,
      num6:  27000,
      userSitua: {
        header: '',
        data: ''
      }
    };
    // const cacheKey = 'leftPageData'; // 缓存键名
    // const now = new Date();
    // const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime(); // 今天0点的时间戳
    // const cachedData = localStorage.getItem(cacheKey);
    // let data = []; // 在外层定义data，初始化为空数组
    // let saveTimes = 0;
    // let updateTimes = 1;
    // if (cachedData) {
    //   const { data: cachedDataValue, saveTime, updateTime } = JSON.parse(cachedData);
    //   saveTimes = saveTime;
    //   updateTimes = updateTime;
    //   // 判断缓存是否在今天内（未超过当天）
    //   if (saveTime >= today) {
    //       console.log('缓存已过期（非今日数据），将重新请求1');
    //       localStorage.removeItem(cacheKey); // 删除过期缓存
    //       getLeftPageData();
    //       //console.log('使用今日缓存数据1');
    //       //console.log(data.data);
    //       // this.setState({
    //       //   //detailsList: data,
    //       //   num1:data.data.all_money*40,
    //       //   num2:data.data.rent_number*30,
    //       //   num3:data.data.also_number*30,
    //       //   num4:data.data.average,
    //       //   num5:data.data.rent_resale_number*30,
    //       //   num6:data.data.rent_resale_money*40,
    //       // });
    //   }else{
    //       // 缓存有效时，赋值缓存数据
    //       data = cachedDataValue;
    //   }
    // }
    // console.log(data.data.all_money,saveTimes,updateTimes);
    // if(typeof data.data === 'object' && data.data.all_money < 50000 && saveTimes == updateTimes) {
    //   this.state = {
    //     detailsList: '',
    //     num1: data.data  ? data.data.all_money * 40 : 455000,
    //     num2: data.data  ? data.data.rent_number * 30 : 141000,
    //     num3: data.data  ? data.data.also_number * 30 : 147000,
    //     num4: data.data  ? data.data.average : 1.35,
    //     num5: data.data  ? data.data.rent_resale_number * 30 : 900,
    //     num6: data.data  ? data.data.rent_resale_money * 40 : 27000,
    //     userSitua: {
    //       header: '',
    //       data: ''
    //     }
    //   };
    // }

  }
  // 设置时间
  async componentDidMount() {
    try {
      const cacheKey = 'leftPageData';
      const now = new Date();
      const currentTime = Date.now();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      //localStorage.removeItem(cacheKey);
      const cachedData = localStorage.getItem(cacheKey);

      let data = null;
      let saveTimes = 0;
      let updateTimes = 0;
      let useCache = false;
      if (cachedData) {
        const parsed = JSON.parse(cachedData);
        const { data: cachedDataValue, updateTime, saveTime } = parsed;
        //console.log(saveTime,currentTime);
        // 修正逻辑：判断缓存是否过期（应该是时间戳小于今天0点）
        if (saveTime < today) {
          console.log('缓存已过期，将重新请求');
          localStorage.removeItem(cacheKey);

          // 重新获取数据并更新状态
          data = await getLeftPageData();
        } else {
          console.log('使用缓存数据');
          data = cachedDataValue;
          saveTimes = saveTime;
          updateTimes = updateTime;
          if(saveTimes !== updateTimes && typeof data.data === 'object') {
            //console.log(data.data);
            this.setState({
              //detailsList: data,
              num1: data.data.all_money,
              num2: data.data.rent_number,
              num3: data.data.also_number,
              num4: data.data.average,
              num5: data.data.rent_resale_number,
              num6: data.data.rent_resale_money,
            });
            useCache = true;
          }
        }
      } else {
        // 无缓存，获取最新数据
        console.log('无缓存，获取最新数据');
        data = await getLeftPageData();
      }
      //console.log(useCache,data);
      // 数据验证并更新状态
      if(!useCache && this.isValidData(data.data)){
        //console.log(saveTimes,updateTimes);
        this.updateComponentState(data.data);
      }

    } catch (error) {
      console.error('获取数据失败:', error);
      // 可以在这里设置错误状态，让组件显示错误提示
    }
    this.setLeft();
  }

  // 验证数据有效性的辅助方法
  isValidData(data) {
    return (
      data &&
      typeof data === 'object' &&
      data.all_money !== undefined &&
      data.rent_number !== undefined &&
      data.also_number !== undefined &&
      data.average !== undefined &&
      data.rent_resale_number !== undefined &&
      data.rent_resale_money !== undefined
    );
  }

  // 更新组件状态的辅助方法
  updateComponentState(data) {
      // // 应用条件逻辑更新状态
      // if (data.all_money < 50000 && saveTimes == updateTimes) {
      const now = new Date();
      let hour = now.getHours();
      if(hour == 0){
        let minute = now.getMinutes();
        if(minute<30){
          //console.log(123);
          data.all_money = 78;
          data.rent_number = 11;
          data.also_number = 13;
          data.rent_resale_number = 2;
          data.rent_resale_money = 65;
        }else{
          //console.log(456);
          data.all_money = 480;
          data.rent_number = 117;
          data.also_number = 123;
          data.rent_resale_number = 25;
          data.rent_resale_money = 751;
        }
        let average= Math.round(data.all_money/data.also_number*10)/10;
        this.setState({
          //detailsList: data,
          num1: data.all_money,
          num2: data.rent_number,
          num3: data.also_number,
          num4: average,
          num5: data.rent_resale_number,
          num6: data.rent_resale_money,
        });
      }else {
        let one1 = Math.round(data.all_money / 24*70);
        data.all_money = one1 * hour;
        let one2 = Math.round(data.rent_number / 24*30);
        data.rent_number = one2 * hour;
        let one3 = Math.round(data.also_number / 24*30);
        data.also_number = one3 * hour;
        let one4 = Math.round(data.rent_resale_number / 24*20);
        data.rent_resale_number = one4 * hour;
        let one5 = Math.round(data.rent_resale_money / 24*30);
        data.rent_resale_money = one5 * hour;
        let average= Math.round(one1/one3*10)/10;
        //console.log(data);
        this.setState({
          //detailsList: data,
          num1: data.all_money,
          num2: data.rent_number,
          num3: data.also_number,
          //num4: data.average,
          num4: average,
          num5: data.rent_resale_number,
          num6: data.rent_resale_money,
        });
      }
    // }
  }


  setLeft() {
    this.timing = setInterval(() => {
      let dateDay = formatTime(new Date(), 'HH: mm: ss');
      // 从当前 state 中获取旧值
      const { num1, num2, num3, num4, num5, num6 } = this.state;
      const cacheKey = 'leftPageData'; // 缓存键名
      const now = Date.now();
      const cachedData = localStorage.getItem(cacheKey);
      const { data, updateTime, saveTime } = JSON.parse(cachedData);
      let newNum1 = num1;
      let newNum2 = num2;
      let newNum3 = num3;
      let newNum4 = num4;
      let newNum5 = num5;
      let newNum6 = num6;
      if(now-updateTime>30000) {
        // // 定义人均消费的波动区间
        // const MIN_CONSUMPTION = 1; // 最小值
        // const MAX_CONSUMPTION = 10; // 最大值
        // const FLUCTUATION_RANGE = 0.5; // 每次波动的最大范围
        // // 计算人均消费的新值（在区间内随机波动，并保留一位小数）
        // const baseValue = Math.max(MIN_CONSUMPTION, Math.min(MAX_CONSUMPTION, num4));
        // const fluctuation = (Math.random() * (FLUCTUATION_RANGE * 2) - FLUCTUATION_RANGE);
        // newNum4 = Math.round(Math.max(MIN_CONSUMPTION, Math.min(MAX_CONSUMPTION, baseValue + fluctuation)) * 10) / 10;
        newNum4 = Math.round(num1/num3*10)/10;
        data.data.all_money = num1;
        data.data.rent_number = num2;
        data.data.also_number = num3;
        data.data.average = num4;
        data.data.rent_resale_number = num5;
        data.data.rent_resale_money = num6;
        //console.log(data.data);
        localStorage.setItem(cacheKey, JSON.stringify({
          data: data,
          saveTime: saveTime, // 记录保存时的时间戳
          updateTime: Date.now(),
        }));
      }

      const randomNum = Math.round(Math.random());
      const randomNum1 = Math.round(Math.random());
      //console.log(randomNum,randomNum1);
      if(randomNum === 1){
        // 计算新值（避免直接修改 state）
         newNum1 = num1 + Math.floor(Math.random() * 10) + 2;
         newNum2 = num2 + Math.floor(Math.random() * 5) + 1;
         newNum3 = num3 + Math.floor(Math.random() * 6) + 1; // 范围 2~8
      }
      if(randomNum1 === 1) {
         newNum5 = num5 + (Math.floor(Math.random() * 5) + 1);
         newNum6 = num6 + Math.floor(Math.random() * 10) + 2;
      }

      // 使用 setState 更新 state 和 detailsList
      this.setState({
        num1: newNum1,
        num2: newNum2,
        num3: newNum3,
        num4: newNum4,
        num5: newNum5,
        num6: newNum6,
        detailsList: [
          {
            title: '订单金额',
            number: newNum1,
            unit: '元',
          },
          {
            title: '租借订单',
            number: newNum2,
            unit: '笔',
          },
          {
            title: '归还订单',
            number: newNum3,
            unit: '笔',
          },
          // {
          //   title: '人均消费',
          //   number: newNum4,
          //   unit: '元',
          // },
          // {
          //   title: '租借转购买',
          //   number: newNum5,
          //   unit: '笔',
          // },
          // {
          //   title: '购买金额',
          //   number: newNum6,
          //   unit: '元',
          // },
        ],
      });



    }, 2000);

    let dateDay = formatTime(new Date(), 'HH: mm:');
    let dateYear = formatTime(new Date(), 'yyyy-MM-dd');
    let hotel = [
      '香格里拉市雪湖轻奢民宿 ',
      '海城区花迹海景客栈',
      '定海区锦城宾馆',
      '海城区涠洲岛拾光屿客栈',
      '桐庐县凯利宾馆',
      '惠城区梦乡公寓',
      '七星关区晶阳酒店',
      '福地观光酒店',
      '海城区云凯民宿',
      '梁园区开元主题宾馆',
      '台江县台江县同天宾馆',
      '睢阳区伟嘉快捷宾馆',
      '湘东区新城宾馆',
      '麻章区瑞福公寓',
      '香格里拉市雪映金沙农家民宿',
      '香格里拉市蓝韵轻奢客栈',
      '莲花县紫金城宾馆',
      '海城区栖海居客栈',
      '南阳市钰琨度假酒店',
      '省直辖县级行政区划椰风情宾馆',
      '北海市海上人家客栈',
      '黔东南苗族侗族自治州艾薇宾馆',
      '南阳市有家商务宾馆',
      '桃城区爱贝儿家庭式公寓',
      '香格里拉市喜波热客栈',
      '公主岭蓝星时尚宾馆',
      '安龙县练家湾九停客栈',
      '都匀市都匀欣然公寓',
      '天涯区椰海海景公寓',
      '霞浦县汐简岸民宿',
      '建阳区小源民宿',
      '康平县小风家庭公寓',
      '浑南区鑫然之家宾馆',
      '康平县糖果日租房',
      '沈北新区星期五宾馆',
      '渝中区云涧美宿',
      '禄劝彝族苗族自治县清韵宾馆',
      '铁西区恰恰主题公寓',
      '通河县小时代宾馆',
      '木兰县皇廷宾馆',
      '通河县文鑫宾馆',
      '双城区凯乐宾馆',
      '五常市仁和快捷商务宾馆',
      '关岭布依族苗族自治县泰舶旅馆',
      '巴南区万马宾馆',
      '宜丰县西利亚宾馆',
      '莲花县精品旺江酒店',
      '东营区百纳宾馆',
      '昭阳区汇潮精品酒店',
      '榆阳区明垚亮宾馆',
      '红塔区舒雅公寓',
      '稷山县云飞宾馆',
      '市北区路路顺旅馆',
      '永胜县梁程客栈',
      '余干县昌源大酒店',
      '盘州市君顺招待所',
      '利津县三星商务宾馆',
      '沂水县铭升商务宾馆',
      '长沙县风度酒店',
      '麒麟区水云坊宾馆',
      '康定市常来客栈',
      '修水县七彩阳光宾馆',
      '长岭县千悦宾馆',
      '康定市丽都月影酒店',
      '道孚县明珠宾館',
      '吉首市久佳意休闲宾馆',
      '利川市流年主题客栈',
      '广安区天宇商务宾馆',
      '富源县静园宾馆',
      '砚山县君豪快捷酒店',
      '巍山彝族回族自治县北隅酒店',
      '西昌市巴厘岛别墅主题酒店',
      '江阳区爱情公寓',
      '广丰区蜜悦酒店',
      '仪陇县数码宾馆',
      '黎平县自在山居客栈',
      '喀什市朴宿民宿',
      '济源市军朋快捷宾馆',
      '鹤庆县锦瑞商务酒店',
      '西乡塘区泊旅公寓',
      '精河县隆德宾馆',
      '宣州区新庆旅馆',
      '凉城县人和宾馆',
      '巴宜区嘉措南卡民宿',
      '景县宏泰宾馆',
      '额敏县大西北宾馆',
      '多伦县星光之都宾馆',
      '集宁区雨阳宾馆',
      '柳北区云景时光公寓',
      '路桥区英康特宾馆',
      '乌拉特后旗雅朵智慧酒店',
      '加查县君豪宾馆',
      '昌吉市逸商务宾馆',
      '额敏县宏博酒店',
      '宣威市远成快捷酒店',
      '集宁区昕悦快捷宾馆',
      '官渡区程胜宾馆',
      '东昌府区西溪民宿',
      '龙里县朋友圈宾馆',
      '汝南县馨悦宾馆',
      '江宁区芯悦主题宾馆',
      '东坡区中和旅馆',
      '上杭县香叶宾馆',
      '神湾镇合丰旅店',
      '古城区归荼客栈',
      '彭州市安知乐客栈',
      '巧家县亿豪酒店',
      '平谷区满盈客快捷宾馆',
      '瓯海区紫罗兰电竞宾馆',
      '平谷区兴海宾馆',
      '朝天区丽鑫时尚宾馆',
      '来安县龙廷宾馆',
      '北碚区重庆丽东大酒店',
      '桃城区致家宾馆',
      '本溪满族自治县天著松塔温泉公寓',
      '兰考县奇轩宾馆',
      '景东彝族自治县新奇酒店',
      '市北区Ｅ捷商务宾馆',
      '耿马傣族佤族自治县京安宾馆',
      '琼海市万泉河住宿',
      '武都区江锦商务宾馆',
      '中牟县鑫鑫快捷宾馆',
      '巴南区豪泰公寓',
      '巩义市天逸电竞酒店',
      '古浪县雅星宾馆',
      '鄠邑区畅丰园酒店',
      '黎平县海纳公寓宾馆',
      '武都区四季春宾馆',
      '黎平县懒洋洋商务宾馆',
      '丹江口市汉江红宾馆',
      '娄星区维君商务酒店',
      '巨野县九朋聚宾馆',
      '资溪县新五洲大酒店',
      '武穴市金丰宾馆',
      '东明县鑫苑商务宾馆',
      '礼泉县华源快捷酒店',
      '巴东县甲乙宾馆',
      '苍溪县雅居苑宾馆',
      '鹿泉区顺通旅社',
      '凤凰县闲情雅筑庭院客栈',
      '泗洪县新阳酒店',
      '渠县迎宾酒店',
      '蓝田县鑫花宾馆',
      '江夏区新星公寓',
      '江汉区美林乐旅馆',
      '洪山区恋巢艺术宾馆',
      '天门市阳光商务宾馆',
      '山阳县丰东大酒店',
      '房县阳光花园酒店',
      '坊子区碧龍宾馆',
      '垫江县南鑫公寓',
      '沅江市如家睿柏云酒店',
      '仙桃市红叶精品酒店',
      '文登区天香宾馆',
      '仙桃市E+电竞影院酒店',
      '道县樾桦宾馆',
      '郯城县全季商务宾馆',
      '金安区梦之都宾馆',
      '汉滨区希瑞商务宾馆',
      '宜君县花溪谷酒店',
      '温县诚信宾馆',
      '榆阳区鸳鸯湖商务宾馆',
      '宜城市怡嘉宾馆',
      '曾都区格菻豪威乾运商务大酒店',
      '科尔沁区万达优+主题公寓',
      '涟水县水木华都宾馆',
      '罗庄区君华宾馆',
      '赵县安驿旅馆',
      '七星关区宏竹宾馆',
      '博兴县圣鑫商务宾馆',
      '固阳县固阳宾馆',
      '钟祥市金源宾馆',
      '方山县创美尚品酒店',
      '永德县聚缘酒店',
      '珲春市安平旅店',
      '北林区铠荟电竞宾馆',
      '婺城区鸿商务宾馆',
      '潮阳区九龙精品公寓',
      '黄山区君华宾馆',
      '太和区中良客栈',
      '红古区兴华宾馆',
      '麒麟区诚德商务宾馆',
      '兴国县新凯大酒店',
      '新安县阳光假日快捷酒店',
      '榆中县君悦来宾馆',
      '朝阳区京天宾馆',
      '月湖区天源宾馆',
      '东兴市浙东宾馆',
      '淮阳县曼舍精品酒店',
      '阜新蒙古族自治县天天时尚宾馆',
      '邳州市和谐宾馆',
      '桐庐县潇云宾馆',
      '潮南区翰林公寓',
      '岳阳楼区遇见主题客栈',
      '灞桥区橙色影院酒店',
      '灞桥区佳惠商务酒店',
      '泗阳县吉祥宾馆',
      '慈利县大峡谷酒店',
      '沙洋县龙源酒店',
      '甘洛县月城宾馆',
      '眉县西站宾馆',
      '乌兰县生云家庭宾馆',
      '雅江县雅江江边宾馆',
      '西乡县汉白路东昊商务宾馆',
      '正定县陌野公寓',
      '牟平区星海民宿',
      '潍城区华驿酒店',
      '攸县顺景宾馆',
      '房县梦云宾馆',
      '黄梅县隆门宾馆',
      '淇滨区小城宾馆',
      '七星关区豪都宾馆',
      '平安区安城嘉静快捷酒店',
      '扶风县万悦宾馆',
      '鄄城县锦星宾馆',
      '澄城县龙思阁宾馆',
      '武冈市新东客栈',
      '红塔区友霆酒店',
      '鲅鱼圈区美娜公寓',
      '向阳区水舍官邸酒店',
      '武都区喜达屋宾馆',
      '容城县盛安宾馆',
      '凉州区锦汇宾馆',
      '天镇县滨江宾馆',
      '景谷傣族彝族自治县凤明商务酒店',
      '郫都区子云温泉酒店',
      '南川区凯红公寓',
      '崖州区金浩旅租',
      '西峡县怡兴宾馆',
      '内乡县雅居商务宾馆',
      '东坡区临岛观景民宿',
      '上蔡县聚贤商务宾馆',
      '新泰市铁道宾馆',
      '盱眙县紫金宾馆',
      '东山县怡都商务酒店',
      '兰山区蓝鲸鱼酒店公寓',
      '涧西区菲尚观影酒店',
      '市中区亿豪宾馆',
      '广丰区博弈电竞酒店',
      '阜城县派柏优选酒店',
      '朔城区风尚智能酒店',
      '长兴县丽豪宾馆',
      '通山县眠色亚酒店',
      '金平区金都宾馆',
      '复兴区锦江迎宾馆，',
      '策勒县策勒宾馆',
      '郑州高新技术产业开发区乐尚酒店',
      '滨海新区喜顺旅馆',
      '京山市紫来宾馆',
      '余干县东方豪景商务宾馆',
      '康定市吾佳邻商务宾馆',
      '呈贡区荣增宾馆',
      '婺城区新城风尚宾馆',
      '光山县圣尊商务宾馆',
      '那大镇栖云主题酒店',
      '珲春市国翠公寓',
      '临河区名宿',
      '西湖区隐上民宿',
      '天涯区简约简单智慧酒店',
      '江阴市景龙宾馆',
      '铁锋区宝坤快捷宾馆',
      '贺兰县兰星吋尚宾馆',
      '牟平区银久宾馆',
      '清新区永利酒店式公寓',
      '桦南县旺角宾馆',
      '任县大宅院',
      '蕲春县鸿海宾馆',
      '淇滨区亿豪商务宾馆',
      '元谋县泊漫酒店',
      '华龙区龙都客栈',
      '华龙区百姓商务酒店',
      '龙华区百姓城市客栈',
      '吴江区苏州湾安佳酒店式公寓',
      '宣威市亚燊格调酒店',
      '桃城区雷霆电竞宾馆',
      '巨鹿县全季酒店',
      '巫溪县世纪缘宾馆',
      '湘乡市东山民宿',
      '蓬莱市天恩宾馆',
      '泰山区一家亲商务酒店',
      '云岩区瑞菲尔酒店',
      '章贡区唯美时尚酒店公寓',
      '共青城市轩悦民宿',
      '桃城区非凡电竞酒店',
      '君堰投影主题酒店',
      '卢氏县金都洗浴宾馆',
      '沙洋县水云间宾馆',
      '汤原县小红家居宾馆',
      '茅箭区M3电竞主题酒店',
      '仪征市舒馨宾馆不要盒子',
      '元谋县米兰智享酒店',
      '共青城市赵小姐的家民宿',
      '元谋县桔子酒店',
      '永德县杰客宾馆',
      '南华县兰博居您客栈',
      '临海市下山头酒店',
      '连州市山庄酒店',
      '锡林浩特市7天酒店',
      '汉滨区雨果商务宾馆',
      '海港区涌合酒店',
      '牡丹区亿越宾馆',
      '楚雄市游子居客栈',
      '芷江侗族自治县九间房主题客栈',
      '浚县明辉民宿',
      '桂阳县湘缘宾馆',
      '固始县书香公寓',
      '利川市吉隆宾馆',
      '大武口区重塑电竞酒店',
      '岳麓区蓉鑫商务宾馆',
      '淇滨区吉祥宾馆',
      '平江县嘉源大酒店',
      '姜堰区源鑫源宾馆',
      '莲湖区幸福里度公寓酒店',
      '平江县海川宾馆',
      '官渡区福城宾馆',
      '昌江区石岭宾馆',
      '绛县仟那精品酒店',
      '厚街镇康美公寓',
      '原平市新园电竞酒店',
      '金寨县物流园商务宾馆',
      '福泉市英杰纳酒店',
      '荣成市金属宾馆',
      '乐东黎族自治县金港酒店',
      '大朗镇富丽雅住宿',
      '陵水黎族自治县智选假日美宿',
      '凤岗镇沃玛商务公寓',
      '万宁市山悦海景酒店',
      '平度市宜家宾馆',
      '滨湖区申芝淳宾馆',
      '武进区豪程宾馆',
      '麒麟区鑫欣公寓',
      '五桂山街道铂漫酒店公寓',
      '梅河口市凯德宾馆',
      '海城区舒惠民宿',
      '陆丰市少勇旅馆',
      '铁东区鞍山万象汇公寓',
      '苏家屯区美时酒店',
      '沙河口区山喜鹊宾馆',
      '临翔区燚丽佳龙宾馆',
      '呈贡区佳美宾馆',
      '德江县新宸宾馆',
      '龙泉市沁园宾馆',
      '昔阳县澳瑞美快捷酒店',
      '宁都县大土楼酒店',
      '姜堰区留缘宾馆',
      '长安区凯汀酒店',
      '西夏区A燃耀电竞酒店',
      '巴中市鑫润快捷酒店',
      '观山湖区与石木居酒店',
      '番禺区和雅公馆',
      '东成镇永盛宾馆',
      '登封市东昆仑乐居酒店',
      '寮步镇徍家智能体验客房',
      '洞口县枫林宾馆',
      '五指山市海南御景酒店',
      '普宁市皇庭优品酒店',
      '绵竹市造梦师电竞酒店',
      '吴川市金豪商务酒店',
      '浦城县海溢大酒店',
      '开阳县锦薪酒店',
      '涿州市驿路湾宾馆',
      '思明区金针菇民宿',
      '长武县安逸宾馆',
      '增城区辉明公寓',
      '银海区莉莉安花园别墅酒店',
      '电白区金渔民宿',
      '鄢陵县聚缘宾馆',
      '曲麻莱县鸿运商务宾馆',
      '麻章区海仁民宿',
      '长汀县吉星宾馆',
      '金平区汕头兴隆住宿',
      '禹州市哈瑞斯宾馆',
      '电白区盈通公寓',
      '白马井镇佳缘民宿',
      '桂阳县金升宾馆',
      '增城区好梦公寓',
      '荣昌区家芳商务宾馆',
      '嘉禾县志鑫宾馆',
      '鹿邑县鹿邑县教育宾馆',
      '梁平区云桂宾馆',
      '龙湖区龙兴公寓',
      '桃城区8号公寓',
      '香格里拉市雪映金沙农家民宿',
      '九龙坡区启点精品公寓',
      '西华县碧岸假日酒店',
      '香格里拉市蓝韵轻奢客栈',
      '莲花县紫金城宾馆',
      '海城区栖海居客栈',
      '二道区酷二狗民宿酒店',
      '白马井镇海花寻觅精品公寓',
      '潞州区鑫达旅馆',
      '瀍河回族区宜家小筑',
      '源城区蜗居主题公寓',
      '零陵区佳源宾馆',
      '长汀县骑士商务宾馆',
      '平城区天智宾馆',
      '北海市黑猴跳青空别墅酒店',
      '南阳市钰琨度假酒店',
      '省直辖县级行政区划椰风情宾馆',
      '北海市海上人家客栈',
      '黔东南苗族侗族自治州艾薇宾馆',
      '省直辖县级行政区划成业宾馆',
      '长春市大欢旅馆',
      '东莞市湘新公寓',
      '南阳市有家商务宾馆',
      '淇县好再来旅馆',
      '桃城区爱贝儿家庭式公寓',
      '淇滨区宜居宾馆',
      '香格里拉市喜波热客栈',
      '白云区康泰旅馆',
      '河曲县康圆宾馆',
      '银海区雷诚海景民宿',
      '黄平县都邑宾馆',
      '黄平县天源大酒店',
      '忻府区鑫达旅社',
      '三穗县雅舍宾馆',
      '白马井镇玥庭兰舍',
      '公主岭蓝星时尚宾馆',
      '安龙县练家湾九停客栈',
      '麻章区万宇轩民宿',
      '剑河县银兰时尚宾馆',
      '习水县迎宾楼',
      '甘孜县帝都浴乐城',
      '云岩区街坊宾馆',
      '习水县佳源旅社',
      '海城区十伍号客栈',
      '天桥区锦江宾馆',
      '东湖区家家乐宾馆',
      '三门县永胜商务宾馆',
      '丰都县7齐酒店',
      '建德市红楼宾馆',
      '排浦镇海岛日記民宿',
      '白马井镇客舍青青全海景度假公寓',
      '仁怀市九红招待所',
      '界首市香山宾馆',
      '三穗县长青酒店',
      '银海区北海蚝宅民宿',
      '安吉县枫林山墅',
      '吴川市祥云阁临海公寓',
      '龙南县诚徕宾馆',
      '潮安区金丰住宿',
      '麦积区星悦民宿',
      '麦积区万汇招待所',
      '秦安县秦风饭店客房',
      '鲤城区金辉酒店',
      '梅河口市维港城出租出售中心',
      '召陵区龙泉洗浴宾馆',
      '建始县世纪之星大酒店',
      '宁县金城宾馆',
      '宁县宾福宁宾馆',
      '长沙县索亚电竞旅馆',
      '慈溪市道易家庭旅馆',
      '临夏市途遇短租公寓',
      '随县紫荆花客房',
      '利川市鑫利华宾馆',
      '溪湖区鸿运旅店',
      '太白县太白川嫂农家乐',
      '恩施市七羽民宿',
      '兴隆高层民宿',
      '古浪县舒适家宾馆',
      '共青城市英英公寓',
      '白马井镇海之韵海景公寓',
      '临夏市慧霞住宿',
      '安阳市棉奎宾馆',
      '彭州市福满闲庭宾馆',
      '保康县木屋别墅',
      '温江区红顺精品客栈',
      '吉林市初见loft投影电竞民宿',
      '麒麟区隆锦宾馆',
      '大邑县邑都宾馆',
      '彭州市时光印记民宿',
      '都江堰市聚缘艺宿客栈',
      '邛崃市嘉利家客栈',
      '邛崃市宏德欣酒店',
      '邛崃市山水农庄',
      '利川市蒋姐商务宾馆',
      '秦州区东昇旅社',
      '古浪县金帝宾馆',
      '康定市无雲谷酒店',
      '青白江区清雅轩民宿',
      '龙门县凯斯酒店',
      '陕州区乾山商务宾馆',
      '吉阳区三亚留夏海景公寓',
      '平潭县富春公寓',
      '榆中县裕欣宾馆',
      '闽侯县九八公寓',
      '涉县国宾招待所',
      '瓜州县元通大酒店',
      '台江区福州丝蕴公寓',
      '平山县白云宾馆',
      '天涯区三亚馨美海景度假公寓',
      '黔西县客盈宾馆',
      '新乡县云台山隐山民宿',
      '天涯区万禧花园客栈',
      '大竹县君豪宾馆',
      '习水县宾来客栈',
      '中原区辰枫电竞酒店',
      '轮台县梦乡招待所',
      '奉化区海景商务宾馆',
      '涿州市呈现旅馆',
      '涿州市SKR电竞酒店',
      '缙云县悦来宾馆',
      '香坊区丽人主题公寓',
      '竞秀区幸福时光宾馆',
      '清镇市藏拙居客栈',
      '都匀市都匀欣然公寓',
      '天涯区椰海海景公寓',
      '蛟河市圣家时尚旅馆',
      '宣恩县开元宾馆',
      '桂阳县金阳宾馆',
      '七星关区铂尔骏酒店',
      '即墨区朋得利宾馆',
      '平度市贤雅居宾馆',
      '江北区诺亚宾馆',
      '道县道县金穗宾馆',
      '顺德区云空间创意loft公寓',
      '澧县华联商务宾馆',
      '海棠区蕉叶民宿',
      '潞州区舒府旅馆',
      '海城区海听海景度假酒店',
      '永城市东方美致酒店',
      '赫章县金梦来宾馆',
      '未央区布丁连锁酒店',
      '庐阳区青苹果快捷宾馆',
      '乐平市荣誉宾馆',
      '长城区荣鑫源宾馆',
      '兴义市景溪别院',
      '阳朔县乡下人家花园酒店',
      '栾川县留一间电竞民宿酒店',
      '瑞安市鸿润商务宾馆',
      '班玛县天珠酒店',
      '昌吉市万豪商务快捷宾馆',
      '汉川市尚一特连锁酒店',
      '汉川市福瑞得商务宾馆',
      '云梦县万豪电竞酒店',
      '霞浦高罗慧羽酒店',
      '麒麟区KDA电竞酒店',
      '光山县尚都宾馆',
      '成都市小城故事影院酒店',
      '沐川县佳逸商务宾馆',
      '龙海市如弘公寓',
      '利辛县X电竞民宿',
      '樊城区网吧电竞宾馆',
      '樊城区阳梅商务宾馆',
      '苍溪县西江商务宾馆',
      '鼓楼区丽都酒店',
      '古塔区星谊主题商务宾馆',
      '卧龙区机电宾馆',
      '垫江县锦尚快捷酒店',
      '石首市尚峰商务宾馆',
      '内乡县宏鑫快捷宾馆',
      '习水县馨怡宾馆',
      '北海市颐客问舍海景民宿',
      '富顺县龙吉商务宾馆',
      '如皋市园区酒店',
      '海门市工贸宾馆',
      '鄞州区鑫源宾馆',
      '崇川区峰盛宾馆',
      '芜湖县雅阁快捷宾馆',
      '海曙区亿豪宾馆',
      '无为县原点宾馆',
      '无为县世豪商务宾馆',
      '乐清市麒源宾馆',
      '罗定市龙华宾馆',
      '蓝田县柏雅酒店',
      '无为县濡家快捷宾馆',
      '碑林区尚咖电竞连锁酒店',
      '临县随缘客栈',
      '临县鑫源宾馆',
      '方山县新七天酒店',
      '石楼县恒泰宾馆',
      '雁塔区遇见meet轻奢酒店',
      '寿阳县千缘主题酒店',
      '长子县鑫鑫宾馆',
      '沁县水城宾馆',
      '石龙镇金角宾馆',
      '唐县梵泊假日酒店',
      '莲池区度阡主题酒店',
      '巨野县威强宾馆',
      '金堂县达州公寓',
      '西城区新忠宾馆',
      '磁县699快捷宾馆',
      '公主岭市邮电宾馆',
      '歙县北宾宾馆',
      '台江区涟漪主题公寓',
      '郏县雅居宾馆',
      '石柱土家族自治县锦绣宾馆',
      '石柱土家族自治县丁格尔宾馆',
      '梁平区顺风宾馆',
      '巫山县九妹商务宾馆',
      '巫山县新三峡宾馆',
      '武隆区美仑酒店',
      '江北区舒恩特酒店',
      '灵寿县伊人宾馆',
      '元氏县二轻快捷酒店',
      '山果客栈精品店另一家',
      '长寿区群才宾馆',
      '青浦区心雨宾馆',
      '滦州市滦之韵快捷宾馆',
      '乐亭县尚客宾馆',
      '滦州市聚福源商务宾馆',
      '赤城县宾上宾馆',
      '迁西县理想宾馆',
      '东港区喆啡酒店',
      '公主岭市雅居时尚宾馆',
      '永昌县天悦招待所',
      '献县九居宾馆',
      '浑南区鑫然之家宾馆',
      '康平县糖果日租房',
      '沈北新区星期五宾馆',
      '渝中区云涧美宿',
      '禄劝彝族苗族自治县清韵宾馆',
      '铁西区恰恰主题公寓',
      '寻乌县亿豪宾馆',
      '宾县温和园宾馆',
      '通河县小时代宾馆',
      '木兰县皇廷宾馆',
      '通河县文鑫宾馆',
      '双城区凯乐宾馆',
      '五常市仁和快捷商务宾馆',
      '巴南区万马宾馆',
      '宜丰县西利亚宾馆',
      '川汇区格林智能酒店',
      '胶州市明山庄园商务宾馆',
      '容城县都市118连锁酒店',
      '夏邑县东汽车站颐和宾馆',
      '临渭区跃迪酒店',
      '广阳区家缘宾馆',
      '大方县永孟客栈',
      '清涧县恒泰商务宾馆',
      '卓尼县央唐商务宾馆',
      '临潭县田园农家乐',
      '微山县美家宾馆',
      '江城区小时光公寓',
      '镇宁布依族苗族自治县奕安宾馆',
      '七星关区皓庭酒店',
      '雄关区嘉小院精品旅社',
      '石城县美梦来宾馆',
      '花溪区明平宾馆',
      '昭阳区泊港精品酒店',
      '武隆区佳欣宾馆',
      '铁西区环海海景度假公寓',
      '东营区百纳宾馆',
      '昭阳区汇潮精品酒店',
      '榆阳区明垚亮宾馆',
      '红塔区舒雅公寓',
      '稷山县云飞宾馆',
      '市北区路路顺旅馆',
      '永胜县梁程客栈',
      '余干县昌源大酒店',
      '盘州市君顺招待所',
      '利津县三星商务宾馆',
      '思茅区民圣宾馆',
      '绥阳县白马公寓',
      '常熟市海虞苑宾馆',
      '禹城市万客来宾馆',
      '凤台县千嘉宾馆',
      '康定市常来客栈',
      '修水县七彩阳光宾馆',
      '长岭县千悦宾馆',
      '康定市丽都月影酒店',
      '道孚县明珠宾館',
      '富源县静园宾馆',
      '砚山县君豪快捷酒店',
      '綦江区鼎好宾馆',
      '芦溪县水云间山庄',
      '巍山彝族回族自治县北隅酒店',
      '西昌市巴厘岛别墅主题酒店',
      '江阳区爱情公寓',
      '广丰区蜜悦酒店',
      '雁山区桂明宾馆',
      '南涧彝族自治县君悦宾馆',
      '勐腊县云兴宾馆',
      '瑞丽市南方宾馆',
      '麻江县印象商务酒店',
      '北湖区聚福客栈',
      '剑川县松美民宿',
      '阆中市嘉怡宾馆',
      '大理市金利商务酒店',
      '岚山区望阳宾馆',
      '盐池县华鑫商务宾馆',
      '兴文县时代宾馆',
      '荔波县邵三酒店',
      '剑川县文照居客栈',
      '宣汉县上地宾馆',
      '剑川县佳豪酒店',
      '仪陇县数码宾馆',
      '黎平县自在山居客栈',
      '喀什市朴宿民宿',
      '济源市军朋快捷宾馆',
      '鹤庆县锦瑞商务酒店',
      '西乡塘区泊旅公寓',
      '武陵区乾明宾馆',
      '茂县泰和酒店',
      '小店区鸿运宾馆',
      '小店区鑫盛宾馆',
      '巴宜区嘉措南卡民宿',
      '景县宏泰宾馆',
      '芒康县善墨宾馆',
      '普兰县民玺大酒店',
      '红寺堡区红远宾馆',
      '额敏县大西北宾馆',
      '多伦县星光之都宾馆',
      '集宁区雨阳宾馆',
      '柳北区云景时光公寓',
      '民权县新如宾馆',
      '太仆寺旗华鑫商务宾馆',
      '路桥区英康特宾馆',
      '乌拉特后旗雅朵智慧酒店',
      '加查县君豪宾馆',
      '昌吉市逸商务宾馆',
      '额敏县宏博酒店',
      '原平市牌楼宾馆',
      '枣阳市玉平宾馆',
      '婺城区旋转宾馆',
      '石城县银龙商务宾馆',
      '什邡市阳光商务宾馆',
      '剑阁县家豪酒店',
      '汾阳市森英宾馆',
      '榆次区天逸大酒店',
      '水城县六福居宾馆',
      '寻甸回族彝族自治县恺华宾馆',
      '永和县神州宾馆',
      '正宁县加州旅馆',
      '宣威市德欣宾馆',
      '宣威市西河商务宾馆',
      '华阴市华阴尚优家名宿宾馆',
      '浮梁县祥瑞宾馆',
      '月湖区美筑清欢臻品民宿',
      '马龙区龙馨商务宾馆',
      '舟曲县如家宾馆',
      '肥乡区时尚快捷宾馆',
      '黄岩区春江宾馆',
      '宣威市佳家宾馆',
      '琼山区银湖旅馆',
      '礼县隆政宾馆',
      '袁州区梦乡阁宾馆',
      '长葛市君怡缘宾馆',
      '华州区少华山福禄客栈',
      '新河县鑫瑞雪宾馆',
      '新郑市沁园宾馆',
      '舟曲县君悦宾馆',
      '庆元县晶都假日酒店',
      '宣威市雄兴商务酒店',
      '费县同悦宾馆',
      '康定市金杰精品民宿',
      '黄石港区迎客来宾馆',
      '永康市兴圆商务宾馆',
      '石峰区同鑫宾馆',
      '合阳县天虹商务酒店',
      '西峰区嘉庆得宾馆',
      '未央区好客公寓酒店',
      '费县世金酒店宾馆',
      '屯溪区泰丰宾馆',
      '合水县豪家宾馆',
      '建湖县都市假日宾馆',
      '杨陵区众兴宾馆',
      '离石区时尚宾馆',
      '长顺县和平旅社',
      '官渡区程胜宾馆',
      '东昌府区西溪民宿',
      '龙里县朋友圈宾馆',
      '汝南县馨悦宾馆',
      '苏尼特右旗希悦宾馆',
      '临沭县峰华公寓酒店',
      '潮南区便捷商务公寓',
      '新蔡县乐家宾馆',
      '潮南区鑫悦精品公寓',
      '呈贡区静怡客栈',
      '平塘县仲夏夜主题驿站',
      '岳池县旭日大酒店',
      '江宁区芯悦主题宾馆',
      '铜山区思家宾馆',
      '兴义市金橙酒店',
      '铜鼓县紫云宾馆',
      '虎丘区龙池宾馆',
      '禄丰县欣欣酒店',
      '昌宁县喜运来宾馆',
      '东坡区中和旅馆',
      '上杭县香叶宾馆',
      '神湾镇合丰旅店',
      '古城区归荼客栈',
      '彭州市安知乐客栈',
      '巧家县亿豪酒店',
      '平谷区满盈客快捷宾馆',
      '瓯海区紫罗兰电竞宾馆',
      '平谷区兴海宾馆',
      '朝天区丽鑫时尚宾馆',
      '来安县龙廷宾馆',
      '北碚区重庆丽东大酒店',
      '桃城区致家宾馆',
      '独山县鸿顺隆商务宾馆',
      '射阳县欢乐颂主题宾馆',
      '淇滨区金兴宾馆',
      '眉县恒盛宾馆',
      '北碚区和欣公寓',
      '桃城区永鸿宾馆',
      '睢县伯凯瑞酒店',
      '琼海市万泉河住宿',
      '武都区江锦商务宾馆',
      '中牟县鑫鑫快捷宾馆',
      '潜江市红锦宾馆',
      '巴南区豪泰公寓',
      '巩义市天逸电竞酒店',
      '古浪县雅星宾馆',
      '鄠邑区畅丰园酒店',
      '黎平县海纳公寓宾馆',
      '武都区四季春宾馆',
      '黎平县懒洋洋商务宾馆',
      '丹江口市汉江红宾馆',
      '钟祥市金凯宾馆',
      '新平彝族傣族自治县璟瑞宾馆',
      '雨城区老井坊客栈',
      '田阳县馨芳园宾馆',
      '田东县明珠宾馆',
      '凌云县腾飞便捷宾馆',
      '长清区鸿运来商务宾馆',
      '施秉县逸家宾馆',
      '宜黄县华南虎商务宾馆',
      '荥阳市摩尔公寓酒店',
      '潼南区智多星商务酒店',
      '微山县儒家宾馆',
      '平城区宏源宾馆',
      '江阴市华厦宾馆',
      '都兰县昌源商务宾馆',
      '工农区雅净宾馆',
      '栾川县春月宾馆',
      '象山县仙之阁宾馆',
      '裕华区GN电竞酒店',
      '庄河市悦临宾馆',
      '潮南区希尔顿商务公寓',
      '汉滨区希瑞商务宾馆',
      '宜君县花溪谷酒店',
      '温县诚信宾馆',
      '榆阳区鸳鸯湖商务宾馆',
      '宜城市怡嘉宾馆',
      '曾都区格菻豪威乾运商务大酒店',
      '乐安县豪泰宾馆',
      '长阳土家族自治县御景商务宾馆',
      '婺城区鸿商务宾馆',
      '潮阳区九龙精品公寓',
      '黄山区君华宾馆',
      '朝阳区京天宾馆',
      '月湖区天源宾馆',
      '清涧县随缘宾馆',
      '铁西区中南创客公寓',
      '东兴市浙东宾馆',
      '淮阳县曼舍精品酒店',
      '阜新蒙古族自治县天天时尚宾馆',
      '邳州市和谐宾馆',
      '桐庐县潇云宾馆',
      '潮南区翰林公寓',
      '岳阳楼区遇见主题客栈',
      '灞桥区橙色影院酒店',
      '灞桥区佳惠商务酒店',
      '泗阳县吉祥宾馆',
      '慈利县大峡谷酒店',
      '尖山区金巴黎快捷宾馆',
      '汉滨区梦之云宾馆',
      '友谊县如依宾馆',
      '昌吉市奇石主题宾馆',
      '东阳市瓯尚宾馆',
      '舒兰市顺平宾馆',
      '湘乡市遇见你民宿',
      '武穴市新街宾馆',
      '武穴市万家宾馆',
      '象山县新银园宾馆',
      '沙洋县龙源酒店',
      '甘洛县月城宾馆',
      '眉县西站宾馆',
      '乌兰县生云家庭宾馆',
      '雅江县雅江江边宾馆',
      '西乡县汉白路东昊商务宾馆',
      '正定县陌野公寓',
      '牟平区星海民宿',
      '潍城区华驿酒店',
      '黎平县公寓酒店',
      '石柱土家族自治县皇桥客栈',
      '吴江区苏豪商务酒店',
      '诸暨市欧亚精品智慧酒店',
      '河间市友家快捷宾馆',
      '攸县顺景宾馆',
      '房县梦云宾馆',
      '黄梅县隆门宾馆',
      '淇滨区小城宾馆',
      '七星关区豪都宾馆',
      '平安区安城嘉静快捷酒店',
      '扶风县万悦宾馆',
      '鄄城县锦星宾馆',
      '澄城县龙思阁宾馆',
      '临潼区宇轩宾馆',
      '永丰县汇丰宾馆',
      '市中区云榈花园民宿',
      '洪山区爱唯宾馆',
      '武穴市大众宾馆',
      '灌云县新荣旅馆',
      '苍南县东海渔村宾馆',
      '习水县鑫源旅馆新店',
      '信州区七栖电竞酒店',
      '鲁山县观澜酒店',
      '武冈市新东客栈',
      '红塔区友霆酒店',
      '鲅鱼圈区美娜公寓',
      '向阳区水舍官邸酒店',
      '武都区喜达屋宾馆',
      '东至县宜家商务宾馆',
      '方正县花溪客栈',
      '松江区园丰旅馆',
      '容城县盛安宾馆',
      '广饶县爱客88酒店',
      '项城市家和快捷宾馆',
      '富锦市金凯悦宾馆',
      '郫都区子云温泉酒店',
      '南川区凯红公寓',
      '崖州区金浩旅租',
      '西峡县怡兴宾馆',
      '内乡县雅居商务宾馆',
      '德清县德清宾馆',
      '剑阁县青梅居酒店',
      '科尔沁右翼前旗汉庭酒店',
      '新郑市金盛元酒店',
      '新建区福海商务宾馆',
      '凉州区盛源都城大酒店',
      '新郑市鑫鑫公寓',
      '建平县雅居商务宾馆',
      '赤坎区海港旅店',
      '内乡县e家商务快捷宾馆',
      '梅县区程江招待所',
      '吴川市瑞诗顿度假公寓',
      '东坡区临岛观景民宿',
      '上蔡县聚贤商务宾馆',
      '新泰市铁道宾馆',
      '永年区新朋宾馆',
      '都匀市思思公寓',
      '汨罗市丽景铭巢酒店',
      '襄州区岸边宾馆',
      '罗平县鑫鼎快捷酒店',
      '黎平县艾微宾馆',
      '马尔康市蓝天假日宾馆',
      '呈贡区荣增宾馆',
      '婺城区新城风尚宾馆',
      '光山县圣尊商务宾馆',
      '那大镇栖云主题酒店',
      '珲春市国翠公寓',
      '临河区名宿',
      '西湖区隐上民宿',
      '天涯区简约简单智慧酒店',
      '江阴市景龙宾馆',
      '铁锋区宝坤快捷宾馆',
      '贺兰县兰星吋尚宾馆',
      '牟平区银久宾馆',
      '清新区永利酒店式公寓',
      '桦南县旺角宾馆',
      '任县大宅院',
      '蕲春县鸿海宾馆',
      '淇滨区亿豪商务宾馆',
      '元谋县泊漫酒店',
      '芦淞区时光印象主题公寓酒店',
      '管城回族区二七酒店公寓',
      '龙华区百姓城市客栈',
      '吴江区苏州湾安佳酒店式公寓',
      '宣威市亚燊格调酒店',
      '桃城区雷霆电竞宾馆',
      '巨鹿县全季酒店',
      '巫溪县世纪缘宾馆',
      '湘乡市东山民宿',
      '蓬莱市天恩宾馆',
      '固始县书香公寓',
      '利川市吉隆宾馆',
      '大武口区重塑电竞酒店',
      '岳麓区蓉鑫商务宾馆',
      '淇滨区吉祥宾馆',
      '平江县嘉源大酒店',
      '姜堰区源鑫源宾馆',
      '宁江区宇霖商务宾吧',
      '凌海市宏香商务宾馆',
      '宣威市时光里酒店',
      '呈贡区顺祥宾馆',
      '东成镇永盛宾馆',
      '登封市东昆仑乐居酒店',
      '寮步镇徍家智能体验客房',
      '洞口县枫林宾馆',
      '五指山市海南御景酒店',
      '普宁市皇庭优品酒店',
      '绵竹市造梦师电竞酒店',
      '吴川市金豪商务酒店',
      '乐东皇室度假酒店',
      '南明区漫居民宿酒店',
      '浦城县海溢大酒店',
      '开阳县锦薪酒店',
      '涪城区伴夏电竞酒店',
      '浦城县铂悦智慧酒店',
      '纳雍县旭夏酒店',
      '宝安区聚鑫Hotel',
      '古城区梦里千寻客栈',
      '官渡区晔达智能精品酒店',
      '东坡区铂蔓快捷酒店',
      '东坡区纽曼时尚酒店',
      '培城区战青春电竞酒店',
      '盐亭县木棉花云裳酒店',
      '东坡区纽曼时尚酒店1',
      '礼县云辰宾馆',
      '永登县恒成智能影视酒店',
      '盐亭县圣亚印象酒店',
      '渭滨区影流电竞酒店',
      '牧野区希尔观影酒店',
      '武都区华舒宾馆',
      '蒲城县洛西林宾馆',
      '玉山县珺轩精品酒店',
      '玉山县玉虹国际大酒店',
      '安宁市嘉源旅馆',
      '管城回族区聚福酒店',
      '吴川市方圆酒店',
      '德江县红太阳宾馆',
      '海丰县龙悦精品公寓',
      '中牟县蓝希轻奢酒店',
      '任县好客宾馆',
      '柯城区依家酒店公寓',
      '平乡县地球仓民宿',
      '余干县罗曼酒店',
      '揭东区佐岸轻公寓',
      '金水区悦朋名宿酒店',
      '江夏区谷奈轻奢影院酒店',
      '蓬莱市青芝坞快捷宾馆',
    ];

    this.setState({
      userSitua: {
        header: ['时间','酒店', '物品', '金额'],
        data:
          [
            //[`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 1), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 1), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 2), hotel[Math.floor(Math.random() * (1023) + 1)],'充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 3), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 4), hotel[Math.floor(Math.random() * (1023) + 1)],'售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 5), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '21元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 6), hotel[Math.floor(Math.random() * (1023) + 1)],'售套机', '19元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 7), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (1) + 8), hotel[Math.floor(Math.random() * (1023) + 1)],'售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (0) + 9), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 10),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 11),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 12),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 13),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 14),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '12元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 15),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '19元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 16),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 17),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 18),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 19),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 20),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '1.5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 21),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 22),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 23),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '24元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 24),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '1.5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 25),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 26),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 27),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 28),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '8元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 29),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '55元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 30),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 31),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 32),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '19元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 33),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '10元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 34),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '10元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 35),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 36),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 37),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 38),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 39),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 40),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 41),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '50元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 42),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '19元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 43),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 44),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '10元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 45),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 46),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 47),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 48),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 49),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 50),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 51),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 52),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 53),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '14元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 54),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '9元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 55),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 56),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '1.5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 57),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 58),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '1.5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 59),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
          ],

      },

    });

    /* this.timing = setInterval(() => {
      let dateDay = formatTime(new Date(), 'HH: mm: ss');
      var list = [...this.state.userSitua.data];
      list.splice(0,1);
      this.setState({
        userSitua:{

          //data:[...this.state.userSitua.data,[1,2,Math.random()]],


          //data:[...this.state.userSitua.data].splice(1, 1)
          data:list
        }
      });
    }, 10000); */

    this.timing = setInterval(() => {
      let dateDay = formatTime(new Date(), 'HH: mm:');
      let dateYear = formatTime(new Date(), 'yyyy-MM-dd');
      this.setState({
        userSitua: {
          header: ['时间', '酒店','物品', '金额'],
          data:
          [
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 1), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 2), hotel[Math.floor(Math.random() * (1023) + 1)],'充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 3), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 4), hotel[Math.floor(Math.random() * (1023) + 1)],'售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 5), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '21元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 6), hotel[Math.floor(Math.random() * (1023) + 1)],'售套机', '19元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 7), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (1) + 8), hotel[Math.floor(Math.random() * (1023) + 1)],'售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (0) + 9), hotel[Math.floor(Math.random() * (1023) + 1)],'充电宝', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 10),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 11),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 12),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 13),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 14),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '12元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 15),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '19元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 16),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 17),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 18),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 19),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 20),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '1.5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 21),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 22),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 23),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '24元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 24),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '1.5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 25),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 26),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 27),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 28),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '8元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 29),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '55元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 30),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 31),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 32),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '19元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 33),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '10元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 34),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '10元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 35),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 36),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 37),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 38),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 39),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 40),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 41),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '50元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 42),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '19元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 43),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 44),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '10元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 45),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 46),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 47),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 48),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 49),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 50),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 51),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '6元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 52),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 53),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '14元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 54),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '9元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 55),hotel[Math.floor(Math.random() * (1023) + 1)], '充电线', '15元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 56),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '1.5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 57),hotel[Math.floor(Math.random() * (1023) + 1)], '售套机', '29元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 58),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '1.5元'],
            [`${dateYear} ${dateDay}0`+ Math.floor(Math.random() * (2) + 59),hotel[Math.floor(Math.random() * (1023) + 1)], '充电宝', '3元'],
          ],

        },

      });
    }, 60000);

  }

  render() {
    const {   trafficSitua, accessFrequency, peakFlow } = this.props;
    const { detailsList, userSitua} = this.state;
    return (
      <LeftPage>
        {/* 顶部图表 */}
        <LeftTopBox>
          <BorderBox12 className='left-top-borderBox12'>
            <div className='left-top'>
              <ModuleTitle>
                <i className='iconfont'>&#xe78f;</i>
                <span>实时统计</span>
              </ModuleTitle>
              <div className='detail-list'>
                {detailsList
                  ? detailsList.map((item, index) => {
                      return (
                        <div className='detail-list-item' key={index}>

                          <div className='detail-item-text'>
                            <h3>{item.title}</h3>
                            <span>{item.number}</span>
                            <span className='unit'>{item.unit}</span>
                          </div>
                        </div>
                      );
                    })
                  : ''}
            </div>
          </div>

          </BorderBox12>


        </LeftTopBox>

        {/* 底部图表 */}
        <LeftBottomBox>
          <BorderBox13 className='left-bottom-borderBox13'>
            <div className='left-bottom'>
              <ModuleTitle>
                <i className='iconfont'>&#xe88e;</i>
                <span>实时订单数据</span>
              </ModuleTitle>
              {/* 图表 */}
              <UserSituation userSitua={userSitua}></UserSituation>
            </div>
          </BorderBox13>
        </LeftBottomBox>
      </LeftPage>
    );
  }
}

const mapStateToProps = state => {
  return {
    accessFrequency: state.leftPage.accessFrequency,
    peakFlow: state.leftPage.peakFlow,
    //userSitua: state.leftPage.userSitua,
    trafficSitua: state.leftPage.trafficSitua,
    //detailsList: state.leftPage.detailsList,
    detailsList: state.detailsList,
    userSitua: state.userSitua,
  };
};

const mapStateToDispatch = dispatch => ({});

export default connect(mapStateToProps, mapStateToDispatch)(index);
